export interface AddressDto {
    street: string
    city: string
    zip: string
}

export interface EntityDtoBase {
    id: string
    createdAt: Date
    lastModifiedAt: Date
}

export enum OrderState {
    NotSet = 0,
    Asked = 1,
    OfferSent = 2,
    OfferAccepted = 3,
    OfferRejected = 4,
    Finished = 5,
    Cancelled = 6,
    CancelledWeather = 7,
}

export enum PaymentState {
    NotSet = 0,
    NotPaid = 1,
    Paid = 2,
    Free = 3,
    PaidWithoutInvoice = 4,
}

export enum ManualPaymentCheckReason {
    None = 0,
    MissingFioToken = 1,
    DueDateOlderThanAutomaticFioHistory = 2,
}

export interface DateOnly {
    year: number
    month: number
    day: number
}

export interface ErrorResponse {
    statusCode: number
    errorCode: number
    message: string
}

export interface IdNameDto {
    id?: string
    name: string
}

export interface DatabaseLookupResponse {
    items: IdNameDto[]
}
